import { styled } from '@material-ui/core/styles'

export const LibraryContainer = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  maxHeight: 600,
  overflow: 'auto'
}))
